import { useCallback } from 'react';
import { useTaskDrawer } from 'components/organisms/task-drawer';
import { useHash } from 'hooks/use-hash';
import { DrawerParams, transformer } from './transformer';

type ShowFunction = () => void;
type HideFunction = () => void;

export const useNotificationsDrawer = (): [
  DrawerParams,
  ShowFunction,
  HideFunction,
] => {
  const [params, setParams] = useHash(transformer);
  const [_, , hideTask] = useTaskDrawer();

  const show = useCallback(() => {
    hideTask();
    setTimeout(() => setParams(['show']), 10);
  }, [hideTask, setParams]);
  const hide = useCallback(() => {
    setParams(['invalid']);
  }, [setParams]);

  return [params, show, hide];
};
